import { EDA } from "motw_core/Dreams/EDreamAttribute";
import IDream from "motw_core/Entity/IDream";
import { dreamBoardService } from "motw_core/Services/DreamBoardService";
import * as React from "react";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import { activeDreamFilterStyle } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Filters/Helpers/ActiveDreamFilterClass";
import { clearedDreamFilters } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Helpers/clearedDreamFilters";
import { DreamsMaxIcon } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Indicators/DreamsMaxIcon";
import Dreams from "source/app/presentation/MainPanel/Dreams/Dreams";
import { AreDreamsFiltered } from "source/app/presentation/MainPanel/Dreams/Helpers/AreDreamsFiltered";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { ArrayUtils } from "source/app/services/ArrayUtils";
import Data from "source/app/services/Data";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { EDragDropObject } from "source/app/services/Shared/EDragDropObject";
import {
    IDropTargetResult,
    useDropTarget,
} from "source/app/services/Shared/Hooks/useDropTarget";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { Sounds } from "source/app/services/Sound/Sounds";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { dreamService } from "../../../../../../../../../motw_core/Services/DreamService";
import { State } from "../../../../../../services/UI/State/State";
import { IDreamsState } from "../../../IDreamsState";
import { DreamsOverloadIcon } from "../../Indicators/DreamsOverloadIcon";

export function ShowBoards({ dreams }: { dreams: Dreams }) {
    const dropTargetResult = useDropTarget<IDream>(
        [EDragDropObject.dreamRow],
        HandleDroppedDreamRowOnBoard
    );

    const dreamCount = dreams
        ? dreams.state.dreamsdata.filter((dream) =>
              dream.attributes.includes(EDA[EDA.board])
          ).length
        : 0;

    const textToDisplay = GetTextToDisplay(dreamCount, dropTargetResult);

    return (
        <span
            ref={dropTargetResult.dropTargetRef}
            style={{
                fontWeight: dropTargetResult.isOver ? "bold" : "initial",
            }}
        >
            <span
                style={{ color: `rgb(241 139 241)` }}
                {...ActiveDreamFilterClass(dreams)}
            >
                <IconWithText
                    iconSuffix={EGlyphicon.knight}
                    whenClicked={() => LoadDreamBoards()}
                    displayAsBlock={false}
                >
                    {textToDisplay}
                </IconWithText>
                <DreamsMaxIcon shouldDisplay={dreamCount === 10} />
                <DreamsOverloadIcon shouldDisplay={dreamCount > 10} />
            </span>
        </span>
    );
}

export function LoadDreamBoards() {
    const dreams = State.ReadClass<IDreamsState>(ESharedComponent.Dreams);

    if (dreams) {
        dreams.setState(boardsOnlyFilters);
    }
}

const boardsOnlyFilters = {
    ...clearedDreamFilters,
    selectedAttributes: [EDA[EDA.board]],
};

function ActiveDreamFilterClass(dreams: Dreams) {
    const className = IsBoardsFilterActive(dreams.state)
        ? activeDreamFilterStyle
        : ``;
    return { className };
}

export function IsBoardsFilterActive(state: IDreamsState) {
    return (
        AreDreamsFiltered(state) &&
        state.selectedAttributes.includes(
            EDA[EDA.board]
        )
    );
}

export function HandleDroppedDreamRowOnBoard(dream: IDream) {
    if (IsDreamOnBoard(dream)) {
        dream.attributes = ArrayUtils.Exclude(
            dream.attributes,
            boardAttributeName
        );

        dream.name = dreamBoardService.GetStringWithoutPosition(dream.name);
    } else {
        dream.attributes = ArrayUtils.AddToWithoutRepeating(
            dream.attributes,
            boardAttributeName
        );
    }

    WithAnimatedProgressBarAsync(async () => {
        Sounds.shoutWhoo.Play();
        await dreamService.UpdateDreamAsync(dream, ClientDataProvider);
        return Data.Load.Single.ByStateTarget<IDreamsState>("dreamsdata");
    });
}

const boardAttributeName = EDA[EDA.board];

const IsDreamOnBoard = (dream: IDream) =>
    dream.attributes.includes(boardAttributeName);

function GetTextToDisplay(
    dreamCount: number,
    dropTargetResult: IDropTargetResult<IDream>
) {
    if (!dropTargetResult.isDragging) {
        return `Board (${dreamCount})`;
    }

    if (!dropTargetResult.isOver) {
        return `Drop here`;
    }

    const isDreamOnBoard = IsDreamOnBoard(dropTargetResult.draggedObject);

    if (isDreamOnBoard) {
        return `Remove from Board`;
    }

    return `Add to Board`;
}
